import { Card, PageHeader } from "antd";

export function Home(props: {}) {
    return (
        <Card>
            <PageHeader title="Přeheld" />
        </Card>
    );
}
